import { render, staticRenderFns } from "./TopTips.vue?vue&type=template&id=7a9ece44&scoped=true"
import script from "./TopTips.vue?vue&type=script&lang=js"
export * from "./TopTips.vue?vue&type=script&lang=js"
import style0 from "./TopTips.vue?vue&type=style&index=0&id=7a9ece44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9ece44",
  null
  
)

export default component.exports